import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-included',
    templateUrl: './included.component.svg',
    styleUrls: ['./included.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncludedComponent {}
